import React from 'react';
import classnames from 'classnames';
import { shape, arrayOf, string, object } from 'prop-types';

export const renderTimeListItem =
  ({ baseClassName }) =>
  (item, index) =>
    (
      <li className={`${baseClassName}__item`} key={index}>
        {item.days && (
          <span className={`${baseClassName}__item__day-part`}>
            {item.days}
          </span>
        )}
        {item.hours && (
          <span className={`${baseClassName}__item__hour-part`}>
            {item.hours}
          </span>
        )}
      </li>
    );

const TimeList = (props) => {
  const { heading, items, baseClassName, modifiers, renderEmptyFallback } =
    props;
  const className = classnames(`${baseClassName}__container`, {
    ...modifiers,
  });
  if ((!items || items.length === 0) && renderEmptyFallback === null) {
    return null;
  }
  return (
    <div className={className}>
      {heading && <div className="contact-card__item__label">{heading}</div>}
      {renderEmptyFallback && <p>{renderEmptyFallback}</p>}
      <ul>{items.map(renderTimeListItem(props))}</ul>
    </div>
  );
};

TimeList.defaultProps = {
  renderEmptyFallback: null,
  baseClassName: 'time-list',
  modifiers: {},
};

export const propTypes = {
  /** classnames compatible object */
  modifiers: object,
  heading: string,
  baseClass: string,
  /** Will not render if items list is empty or undefined */
  items: arrayOf(
    shape({
      days: string.isRequired,
      hours: string.isRequired,
    })
  ),
};

TimeList.propTypes = propTypes;

export const getTimeListItems = (dayProp, hourProp) => (o) => ({
  days: o[dayProp],
  hours: o[hourProp],
});

export default TimeList;
